import React, { useEffect, useState } from "react";
import useCareers from "store/careers/service-hook";
import { useParams } from "react-router-dom";
import DetailPageLayout from "../layouts/DetailPageLayout";
import { useTranslation } from "react-i18next";

const CareerDetailPage = () => {
  const [career, setCareer] = useState();
  const [loading, setLoading] = useState(false);
  const { fetchCareer } = useCareers();
  const { id } = useParams();
  
  useEffect(() => {
    if (!id) return;
    handleSetDetails();
  }, [id]);

  const handleSetDetails = async () => {
    setLoading(true);
    const res = await fetchCareer(id);
    setCareer(res);
    setLoading(false);
  };

  return (
    <DetailPageLayout loading={loading} data={career} setData={setCareer} />
  );
};

export default CareerDetailPage;

export const ShowMore = ({ setter, condition, expanded }) => {
  const { t } = useTranslation("common");
  if (!condition) return null;
  return (
    <p
      className="link text-right fs-12 mt-2"
      onClick={() => setter((val) => !val)}
    >
      {t(expanded ? "SHOW LESS" : "SHOW MORE")}
    </p>
  );
};
